import * as React from 'react';
import ActionPlanEditor from '../../../components/ActionPlanEditor/ActionPlanEditor';
import ApEditorMode from '../../../enums/ApEditorMode';
import {
    ApEditorReducer,
    actionPlanEditorReducer,
} from '../../../sic-lib/reducers/actionPlanEditorReducer';
import { ApPlan } from '../../../sic-lib/types/ApPlan';
import { applyContactChanges } from '../../../store/communicator';
import { useAppDispatch } from '../../../store/hooks';

interface Props {
    plan: ApPlan;
    contactId: number;
}

export default function CommPlanEditor({ plan, contactId }: Props) {
    const dispatch = useAppDispatch();

    const [apState, apDispatch] = React.useReducer<ApEditorReducer>(actionPlanEditorReducer, {
        plan: plan,
        scopedActions: [],
        editIndex: -1,
        location: [],
    });

    React.useEffect(() => {
        apDispatch({
            type: 'SET_EDITOR_PLAN',
            plan,
            location: [],
        });
    }, [plan]);

    const skipEffect = React.useRef<boolean>(true);

    React.useEffect(() => {
        /* A side effect of commiting changes to the apPlan is to persist them to the store */
        if (!skipEffect.current) {
            dispatch(
                applyContactChanges({
                    contactId: contactId,
                    changes: {
                        actionPlan: apState.plan as ApPlan,
                    },
                }),
            );
        } else {
            skipEffect.current = false;
        }
    }, [apState.plan]);

    return (
        <ActionPlanEditor
            apActions={apState.scopedActions}
            apDispatch={apDispatch}
            apEditIndex={apState.editIndex}
            apEditMode={ApEditorMode.plan}
            apLocation={apState.location}
            apRootId={(apState.plan as ApPlan).planId}
            apContactId={contactId}
        />
    );
}
